// Import model
import { FilterOtgWoodCatalogStyleRequest } from '../models/FilterOtgWoodCatalogStyleRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { OtgWoodCatalogStyleCondition } from '../models/OtgWoodCatalogStyleCondition';
import { OtgWoodCatalogStyleFields } from '../models/OtgWoodCatalogStyleFields';
import { OtgWoodCatalogStyleIndexedFields } from '../models/OtgWoodCatalogStyleIndexedFields';

// Import dependency serializers (for complex types)
import { OtgWoodCatalogStyleConditionSerializer } from './OtgWoodCatalogStyleConditionSerializer';
import { OtgWoodCatalogStyleFieldsSerializer } from './OtgWoodCatalogStyleFieldsSerializer';
import { OtgWoodCatalogStyleIndexedFieldsSerializer } from './OtgWoodCatalogStyleIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterOtgWoodCatalogStyleRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterOtgWoodCatalogStyleRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterOtgWoodCatalogStyleRequest instance
   */
  static deserialize(json: string): FilterOtgWoodCatalogStyleRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterOtgWoodCatalogStyleRequest instance
   */
  static fromObject(obj: any): FilterOtgWoodCatalogStyleRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterOtgWoodCatalogStyleRequest');
    }


    const instance: FilterOtgWoodCatalogStyleRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as OtgWoodCatalogStyleIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as OtgWoodCatalogStyleFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        OtgWoodCatalogStyleConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterOtgWoodCatalogStyleRequest instances
   */
  static deserializeArray(json: string): FilterOtgWoodCatalogStyleRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterOtgWoodCatalogStyleRequest instance to a JSON string
   */
  static serialize(instance: FilterOtgWoodCatalogStyleRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterOtgWoodCatalogStyleRequest instance to a plain object
   */
  static toObject(instance: FilterOtgWoodCatalogStyleRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        OtgWoodCatalogStyleConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterOtgWoodCatalogStyleRequest instances to a JSON string
   */
  static serializeArray(instances: FilterOtgWoodCatalogStyleRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
